import { signOut } from "firebase/auth";
import React from "react";
import styled from "styled-components";
import { fireAuth } from "../firebase";
import { CommonButtonStyled } from "./common-styled";

const LogoutButton = () => {
  return (
    <Button
      onClick={async () => {
        await signOut(fireAuth);
      }}
    >
      로그아웃
    </Button>
  );
};

export default LogoutButton;

const Button = styled(CommonButtonStyled)``;
